import { HttpClient } from "@angular/common/http";
import { Validators } from "@angular/forms";
import { of } from "rxjs";
import { APP_VALIDATION_REGEX } from "src/app/app.contant";
import { AdminService } from "../../admin/services/admin.service";
import { FieldEnum, IFormField, SubFieldEnum } from "../../shared/models/form-field";
import { TodayDateValidator } from "../../shared/services/custom-app-validators.service";

const NO_SPECIAL_CHAR = /^([a-zA-Z0-9 ]*)$/;

export const PR_DETAILS_FORMFIELDS : Array<IFormField> = [
    // {
    //     fieldName : "pr_number",
    //     displayName : "PR Number",
    //     defaultValue : "",
    //     labelName : "PR Number",
    //     placeholder : "PR Number",
    //     validators : [Validators.required],
    //     fieldType : FieldEnum.INPUT,
    //     fieldSubType : SubFieldEnum.TEXT,
    //     size : "col-md-2",
            // UIVisible : true
    // },
    {
        fieldName : "pr_date",
        displayName : "PR Date",
        defaultValue : "",
        labelName : "PR Date",
        placeholder : "PR Date",
        validators : [Validators.required],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.DATE,
        size : "col-md-2",
        UIVisible : false,
        required : true
    },
    {
        fieldName : "purchasing_organization",
        displayName : "Purchasing Organization",
        defaultValue : "",
        labelName : "Purchasing Organization",
        placeholder : "Purchasing Organization",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "employee_code",
        displayName : "Employee Code",
        defaultValue : "",
        labelName : "Employee Code",
        placeholder : "Employee Code",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "company_code",
        displayName : "Company Code",
        defaultValue : "",
        labelName : "Company Code",
        placeholder : "Company Code",
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "company_code",
            bindValue : "company_code",
            dataFields : []
        },
        required : true
    },
    {
        fieldName : "purchasing_group",
        displayName : "Purchasing Group",
        defaultValue : "",
        labelName : "Purchasing Group",
        placeholder : "Purchasing Group",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['NO_SPECIAL_CHARACTERS'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "plant",
        displayName : "Plant",
        defaultValue : "",
        labelName : "Plant",
        placeholder : "Plant",
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        updateOn : "blur",
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "plant_code",
            bindValue : "plant_code",
            dataFields : []
        },
        required : true
    },
    {
        fieldName : "division",
        displayName : "Division",
        defaultValue : "",
        labelName : "Division",
        placeholder : "Division",
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "division",
            bindValue : "division",
            dataFields : []
        },
        required : true
    },
    {
        fieldName : "recipient",
        displayName : "Recipient",
        defaultValue : "",
        labelName : "Recipient",
        placeholder : "Recipient",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "registered_email1",
        displayName : "Registered Email1",
        defaultValue : "",
        labelName : "Registered Email1",
        placeholder : "Registered Email1",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['EMAIL_PATTERN'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "registered_email2",
        displayName : "Registered Email2",
        defaultValue : "",
        labelName : "Registered Email2",
        placeholder : "Registered Email2",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['EMAIL_PATTERN'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "billTo",
        displayName : "Contact Person",
        defaultValue : "",
        labelName : "Contact Person",
        placeholder : "Contact Person",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },

    ///////////// NESTED ADDRESS OBJECT ////////////////
    {
        fieldName : "delivery_address_title",
        displayName : "Delivery Address Title",
        defaultValue : "M/S",
        labelName : "Delivery Address Title",
        placeholder : "Delivery Address Title",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "delivery_address_name",
        displayName : "Delivery Address Name",
        defaultValue : "",
        labelName : "Delivery Address Name",
        placeholder : "Delivery Address Name",
        validators : [Validators.required],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "delivery_address_name_1",
        displayName : "Delivery Address Name 1",
        defaultValue : "",
        labelName : "Delivery Address Name 1",
        placeholder : "Delivery Address Name 1",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
    },
    {
        fieldName : "street_or_house_number",
        displayName : "Street or House Number",
        defaultValue : "",
        labelName : "Street or House Number",
        placeholder : "Street or House Number",
        validators : [Validators.required],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "district",
        displayName : "District",
        defaultValue : "",
        labelName : "District",
        placeholder : "District",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
    },
    {
        fieldName : "postal_code",
        displayName : "Postal Code",
        defaultValue : "",
        labelName : "Postal Code",
        placeholder : "Postal Code",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "city",
        displayName : "City",
        defaultValue : "",
        labelName : "City",
        placeholder : "City",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "country",
        displayName : "Country",
        defaultValue : "",
        labelName : "Country",
        placeholder : "Country",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "region",
        displayName : "Region",
        defaultValue : "",
        labelName : "Region",
        placeholder : "Region",
        validators : [Validators.required, Validators.pattern(NO_SPECIAL_CHAR)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "remarks",
        displayName : "Remarks",
        defaultValue : "",
        labelName : "Remarks",
        placeholder : "Remarks",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true
    },
    {
        fieldName : "eccn_number",
        displayName : "ECCN number",
        defaultValue : "N",
        labelName : "eccn_number",
        placeholder : "eccn_number",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        disabled: true,
        required:true
    },
    {
        fieldName : "buyer",
        displayName : "Buyer Suggestion",
        defaultValue : "",
        labelName : "Buyer",
        placeholder : "Buyer",
        validators : null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        updateOn : "blur",
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "buyer",
            bindValue : "buyer",
            dataFields : []
        },
        required : false
    },

    {
        fieldName : "pr_description",
        displayName : "PR Description",
        defaultValue : "",  
        labelName : "PR Description",   
        placeholder : "PR Description",
        validators : [Validators.required, Validators.maxLength(100)],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,   
        size : "col-md-4",
        UIVisible : true,
        updateOn : "blur",
        selectFields : {
            apiAsync$ : of(),   
            bindLabel : "pr_description",
            bindValue : "pr_description",
            dataFields : []
        },
        required : true
    }
]